import * as React from "react";
import {connect} from "react-redux";
import {
    allHoldingsSelector,
    hasHoldings,
    holdingsSelector,
    investmentsEnabled,
    userType
} from "../../../mainReducerMapSelectors";
import {IHolding} from "../../api/HoldingsApi";
import {getSuccessData} from "../common/commonStates";
import {allHoldingsRequestPair, holdingsRequestPair} from "../common/RequesterPairs";
import {UserTypeEnum} from "../../model/UserInfo.model";
import {multipleApiRequesterWrapper} from "../common/MultipleApiRequesterWrapper";
import {InvestmentsComponent} from "./Investments.component";
import {IApplicationRootState} from "../../../applicationState";

export interface IInvestmentsFromStore {
    holdingsForPlan: IHolding[];
    holdingsUniverse: IHolding[];
    hasHoldings: boolean;
    userType: UserTypeEnum;
    investmentsEnabled: boolean;
}

export interface IInvestmentsFromState {
    year?: number | undefined;
    month?: number;
}

export enum HoldingsGroupBy {
    BY_ASSET_CLASS,
    BY_TIER
}

export const InvestmentsPage: React.FunctionComponent<IInvestmentsFromStore & IInvestmentsFromState> = (props) => {
    return <InvestmentsComponent holdingsForPlan={props.holdingsForPlan}
                                 holdingsUniverse={props.holdingsUniverse}
                                 hasHoldings={props.hasHoldings}
                                 userType={props.userType}
                                 investmentsEnabled={props.investmentsEnabled} />;
};

export const mapStateToProps = (state: IApplicationRootState) => {
    return {
        holdingsForPlan: getSuccessData(holdingsSelector(state))!,
        holdingsUniverse: getSuccessData(allHoldingsSelector(state))!,
        hasHoldings: hasHoldings(state),
        userType: userType(state),
        investmentsEnabled: investmentsEnabled(state),
    };
};

const connectedComponent = connect<IInvestmentsFromStore>(mapStateToProps)(InvestmentsPage);

export default multipleApiRequesterWrapper(
    connectedComponent, [
        holdingsRequestPair,
        allHoldingsRequestPair,
    ],
);
